import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { API_BASE_URL } from '../utils/apiConfig';

const BlogDetails = () => {

  const { blogId } = useParams(); // 👈 Get blog blogId from URL
  const [blog, setBlog] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${API_BASE_URL}/blogs/${blogId}`)
      .then(res => {
        if (!res.ok) throw new Error('Failed to fetch blog');
        return res.json();
      })
      .then(data => setBlog(data))
      .catch(err => setError(err.message));
  }, [blogId]);

  if (error) return <p>Error: {error}</p>;
  if (!blog) return <p className='loading-component'>Loading...</p>;

  // Parse content and tags
  let parsedContent = {};
  let tags = [];

  try {
    parsedContent = JSON.parse(blog.content);
    tags = JSON.parse(blog.tags);
  } catch (e) {
    console.error('Failed to parse JSON', e);
  }

  return (
    <div className="blog-container">
      <h1 className="blog-title">{blog.title}</h1>

      <p className="blog-author">
        By: <span className="author-name">{blog.full_name}</span>
      </p>
      <p className="blog-date">{new Date(blog.blog_created).toLocaleDateString()}</p>

      {parsedContent.intro && <p className="blog-paragraph">{parsedContent.intro}</p>}
      {parsedContent.body && <p className="blog-paragraph">{parsedContent.body}</p>}
      {parsedContent.summary && <p className="blog-paragraph">{parsedContent.summary}</p>}
      {parsedContent.conclusion && <p className="blog-paragraph">{parsedContent.conclusion}</p>}

      {parsedContent.tips && (
        <ul className="blog-list">
          {parsedContent.tips.map((tip, index) => (
            <li key={index}>{tip}</li>
          ))}
        </ul>
      )}

      {parsedContent.features?.length > 0 && (
        <ul className="blog-list">
          {parsedContent.features.map((feature, index) => (
            <li key={index}>{feature}</li>
          ))}
        </ul>
      )}

      {parsedContent.example && (
        <pre className="code-block">
          <code>{parsedContent.example}</code>
        </pre>
      )}

      <div className="tags-section">
        <strong>Tags:</strong>
        <div className="tags-list">
          {tags.map((tag, index) => (
            <span key={index} className="tag-item">#{tag}</span>
          ))}
        </div>
      </div>
    </div>

  );

}

export default BlogDetails